import * as tslib_1 from "tslib";
import { expression } from '../../predicate';
import { duplicate } from '../../util';
import { DataFlowNode } from './dataflow';
var FilterNode = /** @class */ (function (_super) {
    tslib_1.__extends(FilterNode, _super);
    function FilterNode(parent, model, filter) {
        var _this = _super.call(this, parent) || this;
        _this.model = model;
        _this.filter = filter;
        _this.expr = expression(_this.model, _this.filter, _this);
        return _this;
    }
    FilterNode.prototype.clone = function () {
        return new FilterNode(null, this.model, duplicate(this.filter));
    };
    FilterNode.prototype.assemble = function () {
        return {
            type: 'filter',
            expr: this.expr
        };
    };
    return FilterNode;
}(DataFlowNode));
export { FilterNode };
//# sourceMappingURL=filter.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-lite/build/src/compile/data/filter.js
// module id = 385
// module chunks = 0